import { getData } from "./base-api";
import ApiUris from "./apiUris";

export const HomeSectionAPI = {
  get(slug) {
    return getData(ApiUris.homeSection.get + `/${slug}`);
  },
};
